<h4>Notify Customer</h4>
<p>Do you want to notify the Customer By Email or Text</p>
<div>
	<button (click)="undo();">Undo Move</button>
	<button>Send Email</button>
	<button>Send Send Text</button>
	<button>Don't Notify Customer</button>
</div>
